import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { cn } from "@theprelude/core";
import { useState } from "react";
import styles from "./collapsible-styles.module.css";

export const useCollapsible = (defaultState?: boolean) => {
  const [open, onOpenChange] = useState(defaultState ?? false);
  return { open, onOpenChange };
};

export const CollapsibleTrigger = CollapsiblePrimitive.Trigger;

export const Collapsible: React.FC<CollapsiblePrimitive.CollapsibleProps> = ({
  children,
  ...props
}) => {
  return (
    <CollapsiblePrimitive.Root {...props}>{children}</CollapsiblePrimitive.Root>
  );
};

export const CollapsibleContent: React.FC<
  CollapsiblePrimitive.CollapsibleContentProps
> = ({ children, className, ...props }) => {
  return (
    <CollapsiblePrimitive.Content
      {...props}
      className={cn(styles.collapsibleContent, className)}
    >
      {children}
    </CollapsiblePrimitive.Content>
  );
};
